import { render, staticRenderFns } from "./ContratPage.vue?vue&type=template&id=886f7f2a&"
import script from "./ContratPage.vue?vue&type=script&lang=js&"
export * from "./ContratPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports